import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TextField, Grid, MenuItem, FormHelperText, FormControl, Autocomplete, Button, Typography, Paper } from '@mui/material';
import { SelectMenu, Icon, InputWithIcon, SimpleModal, BackdropLoader } from '@livable/saas-react-components';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import { US_STATES } from 'src/constants/usStates';
import SmartySDK from 'smartystreets-javascript-sdk';
export const DetailedStreetFinder = observer(_ref => {
  let defaultPropertyAddress = _ref.defaultPropertyAddress,
    error = _ref.error,
    helperText = _ref.helperText,
    name = _ref.name,
    validator = _ref.validator,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _serviceVariableValidate = _ref._serviceVariableValidate,
    _serviceStopValidate = _ref._serviceStopValidate,
    _serviceStartSubmitting = _ref._serviceStartSubmitting,
    _serviceEndSubmitting = _ref._serviceEndSubmitting;
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    zip = _useState2[0],
    setZip = _useState2[1];
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    city = _useState4[0],
    setCity = _useState4[1];
  const _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    line1 = _useState6[0],
    setLine1 = _useState6[1];
  const _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    line2 = _useState8[0],
    setLine2 = _useState8[1];
  const _useState9 = useState('select'),
    _useState0 = _slicedToArray(_useState9, 2),
    state = _useState0[0],
    setState = _useState0[1];
  const _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    addressId = _useState10[0],
    setAddressId = _useState10[1];
  const _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    zipTouched = _useState12[0],
    setZipTouched = _useState12[1];
  const _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    cityTouched = _useState14[0],
    setCityTouched = _useState14[1];
  const _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    stateTouched = _useState16[0],
    setStateTouched = _useState16[1];
  const _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    line1Touched = _useState18[0],
    setLine1Touched = _useState18[1];
  // const [isCustomAddress, setIsCustomAddress] = useState(false);

  const _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    isTouched = _useState20[0],
    setIsTouched = _useState20[1];
  const _useState21 = useState([]),
    _useState22 = _slicedToArray(_useState21, 2),
    tempSearchRes = _useState22[0],
    setTempSearchRes = _useState22[1];
  const _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    isSearchStart = _useState24[0],
    setIsSearchStart = _useState24[1];
  const _useState25 = useState(null),
    _useState26 = _slicedToArray(_useState25, 2),
    streetFinderValue = _useState26[0],
    setStreetFinderValue = _useState26[1];
  const _useState27 = useState([]),
    _useState28 = _slicedToArray(_useState27, 2),
    searchResultItems = _useState28[0],
    setSearchResultItems = _useState28[1];
  const key = '122473708966777755';
  const SmartyCore = SmartySDK.core;
  const Lookup = SmartySDK.usAutocompletePro.Lookup;
  const credentials = new SmartyCore.SharedCredentials(key);
  let delayTimer;
  let clientBuilder = new SmartyCore.ClientBuilder(credentials).withLicenses(['us-autocomplete-pro-cloud']);
  let client = clientBuilder.buildUsAutocompleteProClient();
  const handleValidate = (i, v) => {
    const currentZip = i === 'zip' ? v.trim() : zip.trim();
    const currentCity = i === 'city' ? v.trim() : city.trim();
    const currentState = i === 'state' ? v.trim() : state.trim();
    const currentLine1 = i === 'line1' ? v.trim() : line1.trim();
    const currentLine2 = i === 'line2' ? v.trim() : line2.trim();
    if (/(^\d{5}$)|(^\d{5}-\d{4}$)/.test(currentZip) && currentState !== 'select' && currentCity.trim().length >= 2 && currentLine1.trim().length >= 2) {
      if (validator) validator.setFieldValue(name, "".concat(currentLine1, " ").concat(currentCity, ", ").concat(currentState, " ").concat(currentZip).concat(currentLine2.length ? ', ' + currentLine2 : ''));
    } else {
      if (validator) {
        validator.setFieldValue(name, '');
      }
    }
  };
  const streetSearchHandleResponse = response => {
    const currentSearchResult = [];
    const tempSearchResult = [];
    if (response.result.length === 0) {
      setSearchResultItems([response.search]);
      setTempSearchRes([]);
      return;
    }
    response.result.map(item => {
      currentSearchResult.push("".concat(item.streetLine, " ").concat(item.city, ", ").concat(item.state, " ").concat(item.zipcode).concat(item !== null && item !== void 0 && item.secondary ? ', ' + item.secondary : ''));
      tempSearchResult.push({
        city: item.city,
        street: item.streetLine,
        zip: item.zipcode,
        state: item.state,
        secondary: item.secondary
      });
    });
    setTempSearchRes(tempSearchResult);
    if (defaultPropertyAddress && defaultPropertyAddress.length) currentSearchResult.push(defaultPropertyAddress);
    setSearchResultItems([...new Set(currentSearchResult)]);
  };
  const streetSearchHandleError = (response, searchValue) => setSearchResultItems([searchValue]);
  const handleStreetSearch = e => {
    const searchValue = e.target.value.trim().replace(/  +/g, ' ');
    setLine1(searchValue);
    handleValidate('line1', searchValue);
    if (!line1Touched) setLine1Touched(true);
    clearTimeout(delayTimer);
    delayTimer = setTimeout(function () {
      if (searchValue && searchValue.length < 1) {
        setSearchResultItems([]);
        if (isSearchStart !== false) setIsSearchStart(false);
        return;
      }
      if (isSearchStart !== true) setIsSearchStart(true);
      const lookup = new Lookup(searchValue);
      client.send(lookup).then(streetSearchHandleResponse).catch(errResp => {
        streetSearchHandleError(errResp, searchValue);
      });
    }, 200);
  };
  const handleStreetFinderChange = async (event, newValue) => {
    if (newValue === null) {
      setStreetFinderValue('');
      setLine1('');
      handleValidate('line1', '');
      if (!line1Touched) setLine1Touched(true);
      return;
    }
    if (newValue) {
      if (tempSearchRes.length) {
        const newValueDetails = tempSearchRes.find(item => newValue === "".concat(item.street, " ").concat(item.city, ", ").concat(item.state, " ").concat(item.zip).concat(item !== null && item !== void 0 && item.secondary ? ', ' + item.secondary : ''));
        setStreetFinderValue(newValueDetails.street);
        setLine1(newValueDetails.street);
        setLine2(newValueDetails !== null && newValueDetails !== void 0 && newValueDetails.secondary && newValueDetails !== null && newValueDetails !== void 0 && newValueDetails.secondary.length ? newValueDetails.secondary : '');
        setZip(newValueDetails.zip);
        setCity(newValueDetails.city);
        setState(newValueDetails.state);
        setZipTouched(true);
        setCityTouched(true);
        setStateTouched(true);
        setLine1Touched(true);
        if (validator) validator.setFieldValue(name, "".concat(newValueDetails.street, " ").concat(newValueDetails.city, ", ").concat(newValueDetails.state, " ").concat(newValueDetails.zip).concat(newValueDetails !== null && newValueDetails !== void 0 && newValueDetails.secondary ? ', ' + newValueDetails.secondary : ''));
      }
    }
  };
  const handleTouched = () => {
    if (!isTouched) setIsTouched(true);
    if (!line1Touched) setLine1Touched(true);
  };
  useEffect(() => {
    if (defaultPropertyAddress && defaultPropertyAddress.addressId) {
      setAddressId(defaultPropertyAddress.addressId);
      setZip(defaultPropertyAddress.zip);
      setCity(defaultPropertyAddress.city);
      setLine1(defaultPropertyAddress.street);
      setLine2(defaultPropertyAddress.secondary ? defaultPropertyAddress.secondary : '');
      setState(defaultPropertyAddress.state);
      setZipTouched(true);
      setCityTouched(true);
      setStateTouched(true);
      setLine1Touched(true);
      setStreetFinderValue(defaultPropertyAddress.street);
      setSearchResultItems(["".concat(defaultPropertyAddress.street, " ").concat(defaultPropertyAddress.city, ", ").concat(defaultPropertyAddress.state, " ").concat(defaultPropertyAddress.zip).concat(defaultPropertyAddress !== null && defaultPropertyAddress !== void 0 && defaultPropertyAddress.secondary ? ', ' + defaultPropertyAddress.secondary : '')]);
      if (validator) validator.setFieldValue(name, "".concat(defaultPropertyAddress.street, " ").concat(defaultPropertyAddress.city, ", ").concat(defaultPropertyAddress.state, " ").concat(defaultPropertyAddress.zip).concat(defaultPropertyAddress !== null && defaultPropertyAddress !== void 0 && defaultPropertyAddress.secondary ? ', ' + defaultPropertyAddress.secondary : ''));

      // if (defaultPropertyAddress.isValid) {
      //   setIsCustomAddress(false);
      // } else {
      //   setIsCustomAddress(true);
      // }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultPropertyAddress]);
  const _useState29 = useState(false),
    _useState30 = _slicedToArray(_useState29, 2),
    customModal = _useState30[0],
    setCustomModal = _useState30[1];
  const handleCustomModalOpen = () => {
    setCustomModal(true);
  };
  const hasRequiredAddressFields = () => {
    const zipData = zip.trim();
    const cityData = city.trim();
    const stateData = state.trim();
    const line1Data = line1.trim();
    const zipOk = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zipData);
    const cityOk = cityData.length >= 2;
    const stateOk = stateData !== 'select';
    const line1Ok = line1Data.length >= 2;
    const ok = zipOk && cityOk && stateOk && line1Ok;
    if (!ok) {
      if (!zipTouched) setZipTouched(true);
      if (!cityTouched) setCityTouched(true);
      if (!stateTouched) setStateTouched(true);
      if (!line1Touched) setLine1Touched(true);
      if (validator) validator.setFieldValue(name, '');
    }
    return ok;
  };
  const validateNewAddress = async () => {
    if (!hasRequiredAddressFields()) {
      if (_serviceStopValidate) _serviceStopValidate();
      if (_serviceEndSubmitting) _serviceEndSubmitting();
      return;
    }
    let resp;
    if (addressId) {
      resp = await store.address.updateAddressAsync.run({
        addressId: addressId,
        city: city,
        street: line1,
        secondary: line2,
        zip: zip,
        state: state,
        unitName: null
      }, [addressId]);
    } else {
      resp = await store.address.addNewAddressAsync.run({
        city: city,
        street: line1,
        secondary: line2,
        zip: zip,
        state: state,
        unitName: null
      });
    }
    _serviceStopValidate();
    if (resp && resp.isSuccessful) {
      if (resp.response.isValid) {
        setCustomModal(false);
        _serviceStartSubmitting(resp.response.addressId);
      } else {
        setAddressId(resp.response.addressId);
        handleCustomModalOpen();
        if (_serviceEndSubmitting) _serviceEndSubmitting();
      }
    } else {
      if (_serviceEndSubmitting) _serviceEndSubmitting();
    }
  };
  useEffect(() => {
    if (!!_serviceVariableValidate) validateNewAddress();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_serviceVariableValidate]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 24,
    columnSpacing: 10
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(FormControl, {
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Autocomplete, {
    freeSolo: true,
    value: streetFinderValue,
    variant: "withIcon",
    disablePortal: true,
    openOnFocus: true,
    disabled: disabled,
    id: "detailed-street-finder",
    options: searchResultItems,
    filterOptions: options => options,
    onChange: handleStreetFinderChange,
    renderInput: params => /*#__PURE__*/React.createElement(InputWithIcon, {
      icon: /*#__PURE__*/React.createElement(Icon, {
        type: "location"
      })
    }, /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
      error: line1Touched && line1.trim().length < 2 || error && helperText && line1.trim().length < 2,
      helperText: (line1Touched && line1.trim().length === 0 || error && helperText && line1.trim().length === 0) && 'Street Address is required.' || (line1Touched && line1.trim().length < 2 || error && helperText && line1.trim().length < 2) && 'Street Address is invalid.',
      onChange: handleStreetSearch,
      label: 'Street address',
      onBlur: handleTouched,
      fullWidth: true
    })))
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('company_details.apt_suite'),
    variant: "outlined",
    fullWidth: true,
    disabled: disabled,
    value: line2,
    onChange: e => {
      setLine2(e.target.value);
      handleValidate('line2', e.target.value);
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('company_details.city'),
    variant: "outlined",
    fullWidth: true,
    value: city,
    disabled: disabled,
    onChange: e => {
      setCity(e.target.value);
      handleValidate('city', e.target.value);
    },
    onBlur: () => {
      if (!cityTouched) setCityTouched(true);
    },
    error: cityTouched && city.trim().length < 2 || error && helperText && city.trim().length < 2,
    helperText: (cityTouched && city.trim().length === 0 || error && helperText && city.trim().length === 0) && 'City is required.' || (cityTouched && city.trim().length < 2 || error && helperText && city.trim().length < 2) && 'City is invalid.'
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement("div", {
    onClick: () => {
      if (!stateTouched) setStateTouched(true);
    }
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "state-selector",
    label: t('company_details.state'),
    labelId: "state-selector-label",
    value: state,
    disabled: disabled,
    onChange: e => {
      setState(e.target.value);
      handleValidate('state', e.target.value);
    },
    'custom-attribute': '54-detailed-street-finder',
    error: stateTouched && state === 'select' || error && helperText && state === 'select'
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: "select",
    key: "select",
    disabled: true
  }, "Select state"), US_STATES.map(item => /*#__PURE__*/React.createElement(MenuItem, {
    value: item.code,
    key: item.code,
    'custom-attribute': '55-detailed-street-finder'
  }, item.name))), (stateTouched && state === 'select' || error && helperText && state === 'select') && /*#__PURE__*/React.createElement(FormControl, {
    error: true
  }, /*#__PURE__*/React.createElement(FormHelperText, null, "State is required.")))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('company_details.zip'),
    variant: "outlined",
    fullWidth: true,
    value: zip,
    disabled: disabled,
    onKeyDown: e => {
      if (!(e.keyCode == 8 || e.keyCode == 46) && !/^[0-9-]*$/.test(e.key)) e.preventDefault();
    },
    onChange: e => {
      if (e.target.value.length < 11) {
        setZip(e.target.value);
        handleValidate('zip', e.target.value);
      }
    },
    onBlur: () => {
      if (!zipTouched) setZipTouched(true);
    },
    error: zipTouched && !/(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zip) || error && helperText && !/(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zip),
    helperText: (zipTouched && zip.length === 0 || error && helperText && zip.length === 0) && 'ZIP is required.' || (zipTouched && !/(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zip) || error && helperText && !/(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zip)) && 'ZIP is invalid.'
  }))), /*#__PURE__*/React.createElement(SimpleModal, {
    isOpen: customModal,
    handleOpen: handleCustomModalOpen,
    handleClose: () => setCustomModal(false),
    title: t('Address validation'),
    noPadding: true,
    rightButton: /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      onClick: () => {
        setCustomModal(false);
        _serviceStartSubmitting(addressId);
      },
      'custom-attribute': '56-detailed-street-finder'
    }, t('email.continue_to_login'))
  }, /*#__PURE__*/React.createElement(Paper, {
    style: {
      padding: '32px 40px'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "We could not recognize your address", ' ', /*#__PURE__*/React.createElement("b", null, line1, " ", city, ", ", state, " ", zip, line2 ? ', ' + line2 : ''), /*#__PURE__*/React.createElement("br", null), "If everything is correct, then click on the \"Continue\" button, if not, then cancel and make changes."), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.address.updateAddressAsync.inProgress || store.address.addNewAddressAsync.inProgress
  }))));
});